export default __webpack_public_path__ + "static/media/panel-bkg.b5731657.png";